import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CardBody, Card, Col, Button, Row } from 'reactstrap'
import { Preloading as preloading } from '../../components/UI/Preloader/action';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import fileSaver from 'file-saver';
import { toast } from 'react-toastify';
import {activityLogExtractDownload} from './action'

class ActivityLogComponent extends Component{
    state = {
        fromDate: null,
        toDate: null
    };

    componentDidUpdate(prevProps) 
    { 
        if (this.props.activityLogExtractResponse !== prevProps.activityLogExtractResponse) {
            this.props.preloading(false);
            if (this.props.activityLogExtractResponse.status === "SUCCESS") {
                const data = this.props.activityLogExtractResponse.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                let fileName = 'activity_log_extract'+ moment().format("DD_MMM_YYYY") + '.xlsx'
                fileSaver.saveAs(blob, fileName);           
            } else if (this.props.activityLogExtractResponse.status === "FAILURE") {
                let errorStr = new TextDecoder('utf-8').decode(this.props.activityLogExtractResponse.data);
                let errorObj = JSON.parse(errorStr);
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>
                        {errorObj.message}
                    </div>
                );
            }

            this.setState({
                fromDate: undefined,
                toDate: undefined
            })
        }
    }  

    handleFromDateChange = (date) => {
        this.setState({
            fromDate: date
        });
    }

    handleToDateChange = (date) => {
        this.setState({
            toDate: date
        });
    }

    downloadActivityLogExtract() {
        if (this.state.fromDate && this.state.toDate) {
            this.props.activityLogExtractDownload({
                fromDate: moment(this.state.fromDate).format("DD-MM-YYYY"),
                toDate: moment(this.state.toDate).format("DD-MM-YYYY")
            })
            this.props.preloading(true);
        }
    }

    render(){
        return(
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">Activity Log Extract Download</h4>
                </div>
                <Card>
                <CardBody >
                        <Row>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.fromDate}
                                    onChange={this.handleFromDateChange}
                                    placeholderText="Enter from date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.toDate}
                                    onChange={this.handleToDateChange}
                                    placeholderText="Enter to date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.fromDate || !this.state.toDate}
                                    onClick={() => this.downloadActivityLogExtract()}>
                                    Download
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    activityLogExtractResponse : state.activityLogData.activityLogExtractResponse
})

const mapDispatchToProps = (dispatch) => ({
    preloading: data => { dispatch(preloading(data)) },
    activityLogExtractDownload: data => { dispatch(activityLogExtractDownload(data)) }
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogComponent);